import {
  SendApiRequest,
  SingleContentScenarioMessage,
} from '@inbox-demo-nx/types';

import { convertScenarioMessageToMessagePayload } from './convertScenarioMessageToMessagePayload';

export const sendScenarioMessage = async (
  message: SingleContentScenarioMessage,
  {
    myUserId,
    channelMetaData,
    userMetaData = {},
    channelUrl,
    sendApiRequest,
  }: {
    myUserId: string;
    channelMetaData: Record<string, string>;
    userMetaData?: Record<string, string>;
    channelUrl: string;
    sendApiRequest: SendApiRequest;
  }
) => {
  const sendMessagePayload = convertScenarioMessageToMessagePayload(message, {
    myUserId,
    channelMetaData,
    userMetaData,
  });
  const newMessage = await sendApiRequest({
    type: 'sendMessageAndTranslate',
    data: { channelUrl, params: sendMessagePayload },
  });
  if ((message.reactions?.length ?? 0) > 0)
    await sendApiRequest({
      type: 'addReactionsToMessage',
      data: {
        channelUrl,
        messageId: newMessage.message_id,
        reactions: message.reactions,
      },
    });
};
